import React from 'react'
import { 
    Layout,
    Col, 
    Row,
    Image,
    Button,
} from 'antd';
import Navbar from '../../Components/Navbar/Navbar';
import HeaderImage from '../../Assets/Images/CPM-HEADER-cropped-1.png'

const PrintPreviewExhibitorsPayment = () => {
  return (
    <Layout className='page'>
        <Navbar navKey={'property'}/>
        <Layout className='content-container overflow-y'>
            <Row className='m-4 test-border'>
                <Col>
                    <Row className='mb-5'>
                        <Col span={18}>
                            <Image
                                width="35%" 
                                height={'auto'}
                                src={HeaderImage}
                                alt="login-image"
                                preview={false}
                            />
                        </Col>
                        <Col span={6}>
                            <Row className='soa-address-header'>CHINATOWN EAST GATE</Row>
                            <Row className='soa-address-desc'> SPRINT DISTRIBUTION INCORPORATED
                            LILIA AVENUE BARANGAY COGON
                            ORMOC CITY, LEYTE, 6541 PH</Row>
                        </Col>
                    </Row>
                    <Row className='center mb-4'>
                        <Col>
                            Exhibitor Payment Slip
                        </Col>
                    </Row>
                    <Row className=''>
                        <Col span={24} className='p-2'>
                           <Row>
                                <Col span={19}>
                                    <Row>
                                        <Col span={2}>
                                            Tradename :
                                        </Col>
                                        <Col span={22}>
                                            Barks & Bubbles Pet Grooming and Care
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={5}>
                                    <Row>
                                        <Col span={10}>
                                            Payment No.
                                        </Col>
                                        <Col span={14}>
                                            1
                                        </Col>
                                    </Row>
                                </Col>
                           </Row>
                           <Row>
                                <Col span={19}>
                                    <Row>
                                        <Col span={3}>
                                            Business Address :
                                        </Col>
                                        <Col span={19}>
                                            #15 Countryville Subdivision, Canduman, Mandaue City Cebu
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={5}>
                                    <Row>
                                        <Col span={4}>
                                            Date.
                                        </Col>
                                        <Col span={20}>
                                            Aug 18, 2021
                                        </Col>
                                    </Row>
                                </Col>
                           </Row>
                           <Row>
                                <Col span={19}>
                                    <Row>
                                        <Col span={1}>
                                            TIN :
                                        </Col>
                                        <Col span={22}>
                                            440-108-662-0000
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={5}>
                                    <Row>
                                        
                                    </Row>
                                </Col>
                           </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} className='p-2'>
                            <Row className='border-top-right-left p-2 center'>
                                <Col span={6} className='center'>
                                    Billing No.
                                </Col>
                                <Col span={6} className='center'>
                                    Billing Date
                                </Col>
                                <Col span={6} className='center'>
                                    Particular
                                </Col>
                                <Col span={6} className='center'>
                                    Amount (Php)
                                </Col>
                            </Row>
                            <Row >
                                <Col span={6} className='border-top-right-left p-2'>
                                    test
                                </Col>
                                <Col span={6} className='border-top-right p-2'>
                                    test
                                </Col>
                                <Col span={6} className='border-top-right p-2'>
                                    test
                                </Col>
                                <Col span={6} className='border-top-right p-2'>
                                    test
                                </Col>
                            </Row>
                            <Row >
                                <Col span={6}className='border-top-right-left p-2'>
                                    test
                                </Col>
                                <Col span={6} className='border-top-right p-2'>
                                    test
                                </Col>
                                <Col span={6} className='border-top-right p-2'>
                                    test
                                </Col>
                                <Col span={6} className='border-top-right p-2'>
                                    test
                                </Col>
                            </Row>
                            <Row>
                                <Col span={6} className='test-border p-2'>
                                    test
                                </Col>
                                <Col span={6} className='border-top-right-bottom p-2'>
                                    test
                                </Col>
                                <Col span={6} className='border-top-right-bottom  p-2'>
                                    test
                                </Col>
                                <Col span={6} className='border-top-right-bottom  p-2'>
                                    test
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} className='p-2'>
                            <Row>
                                <Col>
                                    Please make checks payable to:
                                </Col>
                            </Row>
                            <Row >
                                <Col>
                                    BDO Account Number: 0414 - 900 - 23613 (SPRINT DISTRIBUTION INCORPORATED)
                                </Col>
                            </Row>
                            <Row className='my-5'>
                                <Col>
                                    Please advise if any payment made is not reflected in this statement.
                                </Col>
                            </Row>
                            <Row className='my-4'>
                                <Col>
                                    Prepared By,
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <Col>
                                    __________________________
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Row>MYT Admin Administrator</Row>
                                    <Row>Chinatown East Gate</Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={12} className='p-2'>
                            
                        </Col>
                    </Row>
                    <Row className='justify-content-end'>
                            <Col span={2} className='p-2'>
                              <Button
                                // onClick={handleAdd}
                              >
                                Cancel
                              </Button>
                            </Col>
                            <Col span={2} className='p-2'>
                              <Button
                                // onClick={() => navigate('/edit-tenant-rate')}
                                type='primary'
                              >
                                Print
                              </Button>
                            </Col>
                        </Row>
                </Col>
            </Row>
        </Layout>
    </Layout>
  )
}

export default PrintPreviewExhibitorsPayment
